export const promotionTypesMap = {
  MonetaryDiscount: 'MonetaryDiscount',
  PercentDiscount: 'PercentDiscount',
  UptoMonetaryDiscount: 'UptoMonetaryDiscount',
  UptoPercentDiscount: 'UptoPercentDiscount',
};

const discountModifierMap = {
  UpTo: 'UpTo', // 1
  None: 'None', // 2
};

export function getPromotionTypeForModel(model) {
  let promotionType;
  if (model.MoneyAmountOff !== null) {
    if (model.DiscountModifier === discountModifierMap.UpTo) {
      promotionType = promotionTypesMap.UptoMonetaryDiscount;
    } else {
      promotionType = promotionTypesMap.MonetaryDiscount;
    }
  } else if (model.PercentOff !== null) {
    if (model.DiscountModifier === discountModifierMap.UpTo) {
      promotionType = promotionTypesMap.UptoPercentDiscount;
    } else {
      promotionType = promotionTypesMap.PercentDiscount;
    }
  } else {
    promotionType = promotionTypesMap.MonetaryDiscount;
  }

  return promotionType;
}

export const isMonetary = promotionType =>
  promotionType === promotionTypesMap.MonetaryDiscount ||
  promotionType === promotionTypesMap.UptoMonetaryDiscount;

const isUpTo = promotionType =>
  promotionType === promotionTypesMap.UptoMonetaryDiscount ||
  promotionType === promotionTypesMap.UptoPercentDiscount;

export const cleanPromotionTypeData = (promotionType, model) => ({
  DiscountModifier: isUpTo(promotionType) ?
    discountModifierMap.UpTo :
    discountModifierMap.None,
  MoneyAmountOff: isMonetary(promotionType) ? model.MoneyAmountOff : null,
  PercentOff: isMonetary(promotionType) ? null : model.PercentOff,
});
